// @flow
import {createSelector} from 'reselect';

import type {ApplicationStoreType} from 'constants/flow/flowTypes';

import type {
    CreatedOrderItemType,
    CreatedOrderType,
} from 'features/uploadRx/reducers/createdOrder/createdOrderType';

/**
 * Returns created order data
 * @param {ApplicationStoreType} store - redux store
 * @returns {CreatedOrderType} - order data
 */
export const getCreatedOrder = (store: ApplicationStoreType): CreatedOrderType =>
    store.createdOrder;

/**
 * Describes whether a button is available to send a prescription
 * @returns {boolean} - flag
 */
export const isConfirmButtonAble = createSelector(
    getCreatedOrder,
    (order: CreatedOrderType): boolean => {
        if (order.isCommonMethodSelected) {
            return order.commonFile !== '' && order.commonMethod !== 0;
        }
        return order.items.every(
            (item: CreatedOrderItemType) => item.method !== 0 && item.file !== 0,
        );
    },
);
